import { render } from "./DashBoardHeader.vue?vue&type=template&id=edfd0a32"
import script from "./DashBoardHeader.vue?vue&type=script&lang=js"
export * from "./DashBoardHeader.vue?vue&type=script&lang=js"
script.render = render

export default script